import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../../../services/config";
import { useAlert } from "react-alert";
import { Field, Form, Formik, FieldArray } from "formik";
import * as Yup from "yup";
import { Alert } from "react-bootstrap";
import { Input } from "../../../../../_metronic/_partials/controls";
import DefineLoan from "../DefineLoan/DefineLoan";

const DefineSallary = ({
  staffDetails,
  salaryExtraData,
  show,
  reload,
  campusID,
}) => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [AllPayScales, setAllPayScales] = useState([]);
  const [grossSalary, setGrossSalary] = useState(0);
  const [bankList, setbankList] = useState([]);
  const [showerr, setshowerr] = useState(false);
  const [showerror, setshowerror] = useState("Please Fill all Fields");
  const [alreadygeneratedsalary, setalreadygeneratedsalary] = useState({});
  const [extrasData, setExtrasData] = useState([]);
  const [myValues, setMyValue] = useState({});
  const [overAllTotal, setOverAllTotal] = useState(0);
  const [loanModal, setloanModal] = useState(false);

  useEffect(() => {
    getSalaryDetail();
    getAllPayScales();
  }, []);

  const getSalaryDetail = () => {
    fetch(`${baseUrl}/emp-salary-detail/${staffDetails.id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            setalreadygeneratedsalary([data?.payload]);
            setExtrasData(data?.payload?.employee_defined_extras);
            console.log(data.payload);
          } else {
          }
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAllPayScales = () => {
    fetch(`${baseUrl}/payscales`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setAllPayScales(data.payload);
          console.log(data.payload, "this is pay scale");
          // seteobi(data.payload.eobi);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateHandler = (values) => {
    console.log(values.extras);
    console.log(values);
    setloading(true);
    const filteredExtras = values.extras?.filter(
      (item) => item?.value && parseInt(item.value) > 0,
    );

    const data = {
      pay_scale_id: parseInt(values.pay_scale_id),
      collected_gp_fund:
        values.collected_amount == "" ? 0 : parseInt(values.collected_amount),
      auto_clear_deduction: values.auto_clear_deduction,
      ...(filteredExtras.length > 0 && { extras: filteredExtras }),
    };
    fetch(`${baseUrl}/define-salary/${staffDetails.id}?_method=PUT`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          setloading(false);
          show(false);
          reload(campusID);
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Salary has been defined");
              setloading(false);
              show(false);
            } else {
              show(false);
              setloading(false);
              const msgArray = Object.values(data.metadata.message);
              msgArray.map((err) => alert.error(err[0]));
            }
          } else {
            show(false);
            setloading(false);
            // const msgArray = Object.values(data.metadata.message);
            // msgArray.map((err) => alert.error(err[0]));
          }
        });
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        alert.error(err);
        show(false);
      });
  };
  const gettingNetPay = () => {
    if (!extrasData || extrasData.length === 0) return 0;

    const sum_of_allowances = extrasData
      .filter((e) => e.salary_extras?.is_deduction === 0)
      .reduce((sum, e) => sum + Number(e.value || 0), 0);

    const sum_of_deductions = extrasData
      .filter((e) => e.salary_extras?.is_deduction === 1)
      .reduce((sum, e) => sum + Number(e.value || 0), 0);

    const basic = Number(staffDetails?.pay_scale?.basic || 0);

    const grossSalary = basic + sum_of_allowances;
    setGrossSalary(grossSalary);

    const netPay = grossSalary - sum_of_deductions;

    return netPay;
  };

  const calcularteClick = () => {
    const totalAllowances =
      Number(myValues.basic) +
      myValues.extras
        ?.filter((e) => e.is_deduction === 0)
        ?.reduce((sum, e) => sum + Number(e.value || 0), 0);

    const totalDeductions = myValues.extras
      ?.filter((e) => e.is_deduction === 1)
      ?.reduce((sum, e) => sum + Number(e.value || 0), 0);

    setGrossSalary(totalAllowances);
    setOverAllTotal(totalAllowances - totalDeductions);
  };

  //start here

  const AppointStaffSchema = Yup.object().shape({
    pay_scale_id: Yup.string().required("Pay Scale is required"),

    collected_amount: Yup.string()
      .notRequired()
      .matches(/^[0-9\b]+$/, "Collected Amount should be a number"),

    auto_clear_deduction: Yup.boolean(),

    extras: Yup.array().of(
      Yup.object().shape({
        salary_extra_id: Yup.number().required("Extra ID is required"),
        is_deduction: Yup.number()
          .oneOf([0, 1])
          .required(),
        value: Yup.string()
          .required("Value is required")
          .matches(/^[0-9\b]+$/, "Should be a valid number"),
      }),
    ),
  });

  const createEroors = (errors, touched, isSubmitting, values) => {
    if (errors.pay_scale_id && touched.pay_scale_id) {
      setshowerror("Pay scale id is required");
      setshowerr(true);
      return;
    }

    setshowerr(false);

    if (Object.keys(errors).length === 0) {
      if (values.pay_scale_id != "") {
        if (isSubmitting) {
          if (!values.issubmitted) {
            values.issubmitted = true;

            updateHandler(values);
          }
        }
      }
    }
  };

  const defineLoan = () => {
    setloanModal(true);
  };

  const checkTheValue = (values, handleChange) => {
    setMyValue(values);
    console.log(values, "this is values");
  };

  return (
    <div>
      {loading ? (
        <b style={{ color: "green" }}>
          Salary
          {Object.values(alreadygeneratedsalary).length == 0
            ? " Defining "
            : " Updating "}
          Please Wait <span className="spinner-borderd"></span>
        </b>
      ) : (
        <div>
          <div class="container-fluid">
            <div class="row d-flex justify-content-center ">
              <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                <div>
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      issubmitted: false,
                      pay_scale_id: staffDetails?.pay_scale_id || "",
                      basic: staffDetails?.pay_scale?.basic || "",
                      collected_amount:
                        alreadygeneratedsalary?.gp_collected_fund
                          ?.collected_amount || "0",
                      auto_clear_deduction:
                        staffDetails?.auto_clear_deduction === 1,
                      extras:
                        salaryExtraData?.map((item) => {
                          const existingAllowance = extrasData?.find(
                            (e) => e.salary_extra_id == item.id,
                          );
                          const existingDeduction = extrasData?.find(
                            (e) => e.salary_extra_id == item.id,
                          );

                          const value = item?.is_deduction
                            ? existingDeduction?.value ?? "0"
                            : existingAllowance?.value ?? "0";

                          return {
                            salary_extra_id: item.id,
                            is_deduction: item.is_deduction,
                            value,
                          };
                        }) || [],
                    }}
                    validationSchema={AppointStaffSchema}
                    onSubmit={(values) => {}}
                  >
                    {(props) => {
                      const {
                        handleSubmit,
                        errors,
                        touched,
                        setFieldValue,
                        values,
                        isSubmitting,
                        isValid,
                        handleChange,
                        handleBlur,
                      } = props;

                      // setErrorsLis(errors)
                      createEroors(errors, touched, isSubmitting, values);
                      checkTheValue(values, handleChange);

                      return (
                        <>
                          <Form
                            onSubmit={handleSubmit}
                            className="form form-label-right"
                          >
                            <div class="row justify-content-between text-left">
                              <div class="form-group col-sm-6 flex-column d-flex ">
                                <label class="form-control-label">
                                  <b>
                                    Pay Scale{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </b>
                                </label>
                                <select
                                  class="form-select form-control"
                                  name="pay_scale_id"
                                  value={values.pay_scale_id}
                                  onChange={(e) => {
                                    const data = AllPayScales.find(
                                      (item) => item.id == e.target.value,
                                    );

                                    setFieldValue(
                                      "pay_scale_id",
                                      e.target.value,
                                    );
                                    setFieldValue("basic", data.basic);
                                  }}
                                  onBlur={handleBlur}
                                  aria-label="Default select example"
                                >
                                  <option selected value="">
                                    Select Payscale
                                  </option>

                                  {AllPayScales?.map((payscle) => (
                                    <option value={payscle.id}>
                                      {payscle.payscale}
                                    </option>
                                  ))}
                                </select>
                                {errors.pay_scale_id && touched.pay_scale_id && (
                                  <div
                                    style={{ color: "#f87d8a" }}
                                    className="input-feedback"
                                  >
                                    Pay scale id is required
                                  </div>
                                )}
                              </div>
                            </div>

                            <h3 className="m-3"> Salary Allowance</h3>
                            <div class="row justify-content-between text-left">
                              <div class="form-group col-sm-4 flex-column d-flex">
                                <label class="form-control-label">
                                  <b>Basic Salary</b>
                                </label>
                                <Field
                                  disabled
                                  name="basic"
                                  component={Input}
                                  placeholder="Basic"
                                />
                              </div>
                            </div>

                            <FieldArray name="extras">
                              {() => (
                                <div className="row text-left">
                                  {values.extras?.map((extra, index) => {
                                    const item = salaryExtraData.find(
                                      (d) => d.id === extra.salary_extra_id,
                                    );
                                    if (item?.is_deduction != 1) {
                                      return (
                                        <div
                                          key={item.id}
                                          className="form-group col-sm-4 flex-column d-flex"
                                        >
                                          <label className="form-control-label">
                                            <b>{item.name}</b>
                                          </label>
                                          <Field
                                            name={`extras[${index}].value`}
                                            component={Input}
                                            placeholder={item.name}
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  })}
                                </div>
                              )}
                            </FieldArray>

                            <h3 className="m-3">Salary Deduction Details</h3>

                            <FieldArray name="extras">
                              {() => (
                                <div className="row text-left">
                                  {values.extras?.map((extra, index) => {
                                    const item = salaryExtraData.find(
                                      (d) => d.id === extra.salary_extra_id,
                                    );
                                    if (item?.is_deduction == 1) {
                                      return (
                                        <div
                                          key={item.id}
                                          className="form-group col-sm-4 flex-column d-flex"
                                        >
                                          <label className="form-control-label">
                                            <b>{item.name}</b>
                                          </label>
                                          <Field
                                            name={`extras[${index}].value`}
                                            component={Input}
                                            placeholder={item.name}
                                          />
                                        </div>
                                      );
                                    }
                                    return null;
                                  })}
                                </div>
                              )}
                            </FieldArray>

                            <div class="row justify-content-between text-left">
                              <div class="form-group col-sm-6 flex-column d-flex">
                                <label class="form-control-label">
                                  <b>Total GP Fund Collected </b>
                                </label>
                                <Field
                                  name="collected_amount"
                                  component={Input}
                                  placeholder="GP Fund Collected"
                                />
                              </div>

                              <div class="form-group col-sm-6 flex-column">
                                <Field
                                  type="checkbox"
                                  name="auto_clear_deduction"
                                  id="auto_clear_deduction"
                                />
                                <label
                                  for="auto_clear_deduction"
                                  class="form-control-label"
                                >
                                  <b>Auto Clear Deduction</b>
                                </label>
                              </div>
                            </div>
                          </Form>
                          {showerr ? (
                            <div id="err">
                              <Alert
                                variant="danger"
                                onClose={() => setshowerr(false)}
                                dismissible
                              >
                                <Alert.Heading>
                                  Oops You Got an Error!
                                </Alert.Heading>
                                <p>{showerror}</p>
                              </Alert>
                            </div>
                          ) : null}
                          <div className="d-flex mb-5">
                            <h4 className="mr-12">
                              <span className="text-color-primary">
                                Gross Salary:
                              </span>{" "}
                              &nbsp; {grossSalary}
                            </h4>
                            <h4>
                              <span className="text-color-primary">
                                Net Pay (Without GP Fund & Welfare Fund):
                              </span>{" "}
                              &nbsp;{" "}
                              {overAllTotal == 0
                                ? gettingNetPay()
                                : overAllTotal}
                            </h4>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <button
                                style={{ alignSelf: "flex-start" }}
                                className="btn btn-primary"
                                onClick={defineLoan}
                              >
                                Salary Loan
                              </button>
                              <button
                                style={{ alignSelf: "flex-start" }}
                                className="btn btn-primary mx-2"
                                onClick={calcularteClick}
                              >
                                Calculate
                              </button>
                            </div>

                            <div class="btns flex_last">
                              <button
                                type="submit"
                                value="Submit"
                                onClick={() => handleSubmit()}
                                // onClick={updateHandler}
                                class="btn btn-success button_blue pl-4 pr-4"
                              >
                                {Object.values(alreadygeneratedsalary).length ==
                                0
                                  ? "Define"
                                  : "Update"}
                              </button>
                              <button
                                onClick={() => show(false)}
                                class="btn_padding_left btn btn-danger btn_width  pl-4 pr-4 ml-3"
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <DefineLoan
        visible={loanModal}
        employeDetails={staffDetails}
        closeModal={() => setloanModal(false)}
        reload={reload}
      />
    </div>
  );
};

export default DefineSallary;
